import React, { useState, useEffect } from "react";
import BlogList from "../components/BlogList";
import BlogPost from "../components/BlogPost";
import { getAllPosts, getPostBySlug, PostMetadata, Post } from "../utils/posts";

interface BlogProps {
  initialSlug?: string | null;
  onNavigate?: (page: string, slug?: string) => void;
}

export default function Blog({ initialSlug, onNavigate }: BlogProps) {
  const [posts, setPosts] = useState<PostMetadata[]>([]);
  const [selectedPost, setSelectedPost] = useState<Post | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPosts = async () => {
      const allPosts = await getAllPosts();
      setPosts(allPosts);

      if (initialSlug) {
        const post = await getPostBySlug(initialSlug);
        if (post) setSelectedPost(post);
      }

      setLoading(false);
    };

    loadPosts();
  }, [initialSlug]);

  const handleSelectPost = async (slug: string) => {
    const post = await getPostBySlug(slug);
    if (post) {
      setSelectedPost(post);
      window.history.pushState({ page: "blog", slug }, "", `/blog/${slug}`);
      window.scrollTo(0, 0);
    }
  };

  const handleBack = () => {
    setSelectedPost(null);
    window.history.pushState({ page: "blog" }, "", "/blog");
    window.scrollTo(0, 0);
  };

  if (loading) {
    return (
      <div className="min-h-screen w-full flex flex-col items-center justify-center bg-Base text-Text pt-16">
        <div className="border-2 border-Text p-8 bg-Crust max-w-md w-full text-center">
          <h2 className="text-4xl font-bold mb-4 font-mono">BLOG.LOG</h2>
          <div className="w-full h-[2px] bg-Sapphire mb-6"></div>
          <p className="text-Subtext0 font-mono mb-8">
            // LOADING...
            <br />
            // SYSTEM_INITIALIZING
          </p>
          <div className="animate-pulse bg-Sapphire w-4 h-4 mx-auto"></div>
        </div>
      </div>
    );
  }

  if (selectedPost) {
    return <BlogPost post={selectedPost} onBack={handleBack} />;
  }

  return <BlogList posts={posts} onSelectPost={handleSelectPost} />;
}
